import { TGetOrderResponse } from '@p2p/services';
import { formatCurrencyAmount } from '@p2p/shared/functions';

import { useDeepLink } from '../useDeepLink';
import styles from './DeepLinkMobile.module.scss';

type DeepLinkMobileDescriptionProps = {
  order: TGetOrderResponse;
};

export const DeepLinkMobileDescription = ({ order }: DeepLinkMobileDescriptionProps) => {
  const { isTinkoff, isRmFlow } = useDeepLink({ order });

  if (isTinkoff || isRmFlow) {
    return (
      <p className={styles.description}>
        Перейдите в приложение и переведите точную сумму
        <span className={styles.price}>{formatCurrencyAmount(order.expected_income)} RUB</span>
        одним платежом
      </p>
    );
  }

  return (
    <p className={styles.description}>
      Перейдите в приложение и переведите точную сумму
      <span className={styles.price}>{formatCurrencyAmount(order.expected_income)} RUB</span>
      одним платежом в банк <span className={styles.bolder}>{order.requisite.bank.name}</span>
    </p>
  );
};
